// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyAj0wLe_Ljt9IosDII8z1wJ4INHghrMMtc',
    authDomain: 'intergal-c1e7a.web.app',
    databaseURL: 'intergal-c1e7a.firebaseio.com',
    projectId: 'intergal-c1e7a',
    storageBucket: 'intergal-c1e7a.appspot.com'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
